import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import {
  editSettingAdminService,
  getSettingAdminService,
} from "../../../services/adminServices";
import { setMetaAction } from "./../../../redux/actions/metaActions/metaActions";

export const settingAdminContext = createContext({
  setting: {},
  setSetting: () => {},
  handleGetSetting: () => {},
  handleEditSetting: () => {},
});

const SettingAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [setting, setSetting] = useState({});

  // Get Setting
  const handleGetSetting = async (event) => {
    event?.preventDefault();

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getSettingAdminService();
      if (status === 200) {
        setSetting(data.result?.setting);
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Edit Setting
  const handleEditSetting = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editSettingAdminService(userData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetSetting();
        dispatch(setMetaAction());
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <>
      <settingAdminContext.Provider
        value={{
          setting,
          setSetting,
          handleGetSetting,
          handleEditSetting,
        }}
      >
        {children}
      </settingAdminContext.Provider>
    </>
  );
};

export default SettingAdminContext;
